import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticStyle:{"display":"flex","flex-direction":"column","min-height":"100vh"}},[_c('VisitorTracker'),_c(VMain,{staticStyle:{"flex":"1"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }